import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../../../services/WiMuleSQL";

export const useGetDispatchSpectrum = (dateEnd, weekSequence, machineId, enabled = true) => {
  const formatDateEnd = (date) => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 0);
    return d.toISOString().split(".")[0];
  };

  const dateEndString = dateEnd ? formatDateEnd(dateEnd) : null;

  const fetchData = async () => {
    const queryString =
      `${WiMuleSQL}/api/BWOS/GetIN12DSPSpectrum` +
      `?dateEnd=${dateEndString}` +
      `&weekSequence=${weekSequence}` +
      `&machineId=${machineId}`;

    const response = await fetch(queryString, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }

    const json = await response.json();
    return json.data ?? null;
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["dispatchSpectrum", dateEndString, weekSequence, machineId],
    queryFn: fetchData,
    enabled: enabled && !!dateEndString && !!weekSequence && !!machineId,
    placeholderData: (previousData) => previousData,
    staleTime: 30000,
    refetchInterval: () =>
      document.visibilityState === "visible" ? 600000 : 6000000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
  });

  return { data, isLoading, isError, error };
};
